import { StyleSheet, View } from 'react-native';

import { StatusBadge } from '@/components/atoms/badge';

export interface BadgeItem {
  readonly label: string;
  readonly variant: 'info' | 'warning' | 'error' | 'success' | 'neutral';
  readonly loading?: boolean;
}

export interface BadgeRowProps {
  readonly badges: readonly BadgeItem[];
  readonly testID?: string;
}

export const BadgeRow = ({ badges, testID }: BadgeRowProps) => {
  if (badges.length === 0) {
    return null;
  }

  return (
    <View style={styles.container} testID={testID}>
      {badges.map((badge, index) => (
        <StatusBadge
          key={`${badge.label}-${badge.variant}-${index}`}
          label={badge.label}
          loading={badge.loading}
          variant={badge.variant}
          style={index > 0 ? styles.badgeSpacing : undefined}
        />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
  },
  badgeSpacing: {
    marginLeft: 4,
  },
});
